import * as React from "react";
const SvgMyLocation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 17"
    {...props}
  >
    <g clipPath="url(#my_location_svg__a)">
      <path
        fill="#B3BAC5"
        d="M8.001 6.332a2.666 2.666 0 1 0 0 5.333 2.666 2.666 0 1 0 0-5.333Zm5.96 2a5.996 5.996 0 0 0-5.293-5.294V1.665H7.335v1.373A5.996 5.996 0 0 0 2.04 8.332H.668v1.333h1.373a5.996 5.996 0 0 0 5.294 5.293v1.374h1.333v-1.374a5.996 5.996 0 0 0 5.293-5.293h1.374V8.332H13.96Zm-5.96 5.333a4.663 4.663 0 0 1-4.666-4.667A4.663 4.663 0 0 1 8 4.332a4.663 4.663 0 0 1 4.667 4.666 4.663 4.663 0 0 1-4.667 4.667Z"
      />
    </g>
    <defs>
      <clipPath id="my_location_svg__a">
        <path fill="#fff" d="M0 .998h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMyLocation;
